module.exports = __webpack_public_path__ + "media/components/login/static/surf-forecast_outside--header_logo-65122677bf62372f3af876a30fac9803.webp";